module.exports = __webpack_public_path__ + "static/media/Fontfabric - MullerRegularItalic.815a6ba7.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/Fontfabric - MullerRegularItalic.otf
// module id = 1071
// module chunks = 0